import { render, staticRenderFns } from "./StatusDescricao.vue?vue&type=template&id=4114271e&lang=html"
import script from "./StatusDescricao.vue?vue&type=script&lang=js"
export * from "./StatusDescricao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports